module.exports = __webpack_public_path__ + "fromGroomToFather-jp-n.6f904371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToFather-jp-n.jpg
// module id = txUT
// module chunks = 0